import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { TFaqCategory } from 'shared/types/faq.types';

const initialState: { isCategoryTab: boolean; categories: TFaqCategory[] } = {
  isCategoryTab: false,
  categories: [],
};

export const categorySlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    setIsCategoryTab: (state, { payload }: PayloadAction<boolean>) => {
      state.isCategoryTab = payload;
    },
  },
});

const category = (state: RootState) => state.entities.faq.category;
const getOrganizations = createSelector(category, state => state);

export const selectors = { getOrganizations };
export const categoryActions = categorySlice.actions;
export const reducer = categorySlice.reducer;
